import React from "react";
import { Link } from "gatsby";
import { cn } from "../lib/helpers";
import { useLocation } from '@reach/router';
import handleSubmit from "../common/handleSubscriptionSubmit";
import * as styles from "../styles/components/subscription-form.module.css";

const SubscriptionForm = (props) => {

  const {
    title
  } = props;

  const currentUrl = useLocation().href;

  return (
    <div className={styles.root}>
      <h5 className={styles.heading}>Stay up to date with all things Chain.io</h5>
      <div id="message" className={styles.message}></div>
      <form 
        method="post" 
        name="Subscription" 
        id="subscription" 
        onSubmit={(event) => handleSubmit(event, currentUrl, title, null)}
      >
        <div className={styles.formFields}>
          <div className={styles.formField}>
            <label htmlFor="email" className="screen-reader-text">Email Address*</label>
            <input type="email" name="email" id="email" placeholder="Email*" required />
          </div>
        </div>
        <button className="btn" type="submit">Subscribe</button>
        <div className={cn("entry-content", styles.legalCopy)}>
          <p>You can unsubscribe anytime. For more details, review our <Link to="/privacy">Privacy Policy</Link>.</p>
        </div>
      </form>
    </div>
  );
}

export default SubscriptionForm;
